import { render, staticRenderFns } from "./UploadCloudIcon.vue?vue&type=template&id=27346802&"
import script from "./UploadCloudIcon.vue?vue&type=script&lang=js&"
export * from "./UploadCloudIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports